module.exports = __webpack_public_path__ + "img/xuqiuguangchang7.1591db8e.png";